import { jsx as l } from "react/jsx-runtime";
const o = (a) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M8 8a4 4 0 0 1 8 0c.151 0 .298.034.43.097l3.03-1.94a1 1 0 0 1 1.08 1.685l-3.015 1.93A7 7 0 0 1 18 12h3a1 1 0 1 1 0 2h-3v1a6 6 0 0 1-.197 1.524l2.71 1.617a1 1 0 1 1-1.026 1.718l-2.514-1.502a6 6 0 0 1-9.946 0L4.513 19.86a1 1 0 0 1-1.026-1.718l2.71-1.617A6 6 0 0 1 6 15v-1H3a1 1 0 1 1 0-2h3q0-.028.002-.055a7 7 0 0 1 .473-2.174L3.461 7.842a1 1 0 1 1 1.078-1.684l3.03 1.94A1 1 0 0 1 8 8m2.586-1.414A2 2 0 0 1 14 8h-4a2 2 0 0 1 .586-1.414",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  o as default
};
